import type { ClassColumnMappingTableData } from '~pages/classes/bulk-upload/types';

/** Enrollio class import fields shown in the import wizard column mapper. */
export const CLASS_MAPPING_TABLE_DATA: Array<ClassColumnMappingTableData> = [
  { header: 'Title', sample: 'Twinkle Star Kids', selectedColumn: '', columnValue: '' },
  { header: 'Class Color', sample: '#E91E63', selectedColumn: '', columnValue: '' },
  { header: 'Hide Class Status', sample: 'no', selectedColumn: '', columnValue: '' },
  { header: 'Location', sample: 'Main Studio', selectedColumn: '', columnValue: '' },
  { header: 'Room', sample: 'Studio A', selectedColumn: '', columnValue: '' },
  { header: 'start age year', sample: '3', selectedColumn: '', columnValue: '' },
  { header: 'start age month', sample: '0', selectedColumn: '', columnValue: '' },
  { header: 'end age year', sample: '7', selectedColumn: '', columnValue: '' },
  { header: 'end age month', sample: '0', selectedColumn: '', columnValue: '' },
  { header: 'Instructor', sample: 'Alex', selectedColumn: '', columnValue: '' },
  {
    header: 'Description (Under 200 Characters)',
    sample: 'Intro to dance',
    selectedColumn: '',
    columnValue: '',
  },
  { header: 'Session', sample: '2025-26', selectedColumn: '', columnValue: '' },
  { header: 'Start Date', sample: '9/1/2025', selectedColumn: '', columnValue: '' },
  { header: 'End Date', sample: '5/31/2026', selectedColumn: '', columnValue: '' },
  {
    header: 'Registration Start Date',
    sample: '8/1/2025',
    selectedColumn: '',
    columnValue: '',
  },
  { header: 'Days', sample: 'Mon, Wed', selectedColumn: '', columnValue: '' },
  { header: 'Start Time', sample: '10:00 AM', selectedColumn: '', columnValue: '' },
  { header: 'End Time', sample: '11:00 AM', selectedColumn: '', columnValue: '' },
  { header: 'Registration Fee', sample: '50', selectedColumn: '', columnValue: '' },
  { header: 'Tuition Fee', sample: '120', selectedColumn: '', columnValue: '' },
  { header: 'Costume Fee', sample: '0', selectedColumn: '', columnValue: '' },
  { header: 'Class Size', sample: '20', selectedColumn: '', columnValue: '' },
  { header: 'Group', sample: 'Ballet', selectedColumn: '', columnValue: '' },
  {
    header: 'Tuition Billing Cycle',
    sample: 'Monthly',
    selectedColumn: '',
    columnValue: '',
  },
  {
    header: 'Billing Frequency Days',
    sample: '14',
    selectedColumn: '',
    columnValue: '',
  },
  { header: 'Hourly Plan Name', sample: '', selectedColumn: '', columnValue: '' },
  { header: 'Billing Day', sample: '1', selectedColumn: '', columnValue: '' },
];

export const IMPORT_CLASS_TEMPLATE_URL = '/import-classes-template.csv';
export const IMPORT_FAMILY_TEMPLATE_URL = '/import-families-template.csv';
